import ReviewAndSubmitFooter from './ReviewAndSubmitFooter';

export default ReviewAndSubmitFooter;
